<template>
  <div v-if="sectionId && profileDataLocal.sections && profileDataLocal.sections[sectionId]">
    <b-form>
      <b-card class="border">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="AwardIcon" size="19" class="mr-50" />
          <h4 class="mb-0">Section Information</h4>
        </div>

        <b-row class="mt-1">
          <!-- Field: Exam Voucher -->
          <b-col cols="12" lg="2" md="2" xs="12">
            <b-form-group label="Section Exam Voucher" label-for="profile-section-exam-voucher">
              <v-select
                id="profile-section-exam-voucher"
                :value="profileDataLocal.sections[this.sectionId].examVoucher"
                :options="examVoucherOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].examVoucher = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Exam Taken -->
          <b-col cols="12" lg="2" md="2" xs="12">
            <b-form-group label="Section Exam Taken" label-for="profile-section-exam-taken">
              <v-select
                id="profile-section-exam-taken"
                :value="profileDataLocal.sections[this.sectionId].examTaken"
                :options="yesNoOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].examTaken = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Exam Passed -->
          <b-col cols="12" lg="2" md="2" xs="12">
            <b-form-group label="Section Exam Passed" label-for="profile-section-exam">
              <v-select
                id="profile-section-exam"
                :value="profileDataLocal.sections[this.sectionId].examPassed"
                :options="yesNoOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].examPassed = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Lab Completed -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Section Lab Completed" label-for="profile-section-lab">
              <v-select
                id="profile-section-lab"
                :value="profileDataLocal.sections[this.sectionId].labCompleted"
                :options="yesNoOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].labCompleted = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Retake -->
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Section Retake" label-for="profile-section-retake">
              <v-select
                id="profile-section-retake"
                :value="profileDataLocal.sections[this.sectionId].retake"
                :options="yesNoActualOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].retake = val)"
                :disabled="isCourseCohort"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Status -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Section Status" label-for="profile-section-status">
              <v-select
                id="profile-section-status"
                :value="profileDataLocal.sections[this.sectionId].status"
                :options="sectionStatusOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].status = val)"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="border">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="CreditCardIcon" size="19" class="mr-50" />
          <h4 class="mb-0">Primary Voucher</h4>
        </div>

        <b-row class="mt-1">
          <!-- Field: Voucher Purchased -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Voucher Purchased" label-for="profile-section-voucher-purchased">
              <v-select
                id="profile-section-voucher-purchased"
                :value="profileDataLocal.sections[this.sectionId].vouchers.primary.voucherPurchased"
                :options="yesNoOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.primary.voucherPurchased = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Voucher Issued -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Voucher Issued" label-for="profile-section-voucher-issued">
              <v-select
                id="profile-section-voucher-issued"
                :value="profileDataLocal.sections[this.sectionId].vouchers.primary.voucherIssued"
                :options="yesNoOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.primary.voucherIssued = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Voucher Code -->
          <b-col cols="12" lg="4" md="6" xs="12">
            <b-form-group label="Voucher Code" label-for="profile-section-voucher-code">
              <b-form-input
                id="profile-section-voucher-code"
                :value="profileDataLocal.sections[this.sectionId].vouchers.primary.voucherCode"
                @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.primary.voucherCode = val)"
                class="w-100"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Voucher Issued Date -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Voucher Issued Date" label-for="profile-section-voucher-issued-date">
              <b-form-datepicker
                id="profile-section-voucher-issued-date"
                :value="profileDataLocal.sections[this.sectionId].vouchers.primary.voucherIssuedDate"
                @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.primary.voucherIssuedDate = val)"
                class="mb-1"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Voucher Expiration Date -->
          <b-col cols="12" lg="2" md="6" xs="12">
            <b-form-group label="Voucher Expiration Date" label-for="profile-section-voucher-expiration-date">
              <b-form-datepicker
                id="profile-section-voucher-expiration-date"
                :value="profileDataLocal.sections[this.sectionId].vouchers.primary.voucherExpirationDate"
                @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.primary.voucherExpirationDate = val)"
                class="mb-1"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="border">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="RefreshCwIcon" size="19" class="mr-50" />
          <h4 class="mb-0">Retake Voucher</h4>
        </div>

        <b-row class="mt-1">
          <b-col cols="12" lg="2" md="3" xs="12">
            <b-form-group label="Retake Voucher" label-for="profile-voucher-retake">
              <v-select
                id="profile-section-retake"
                :value="voucherRetake"
                :options="yesNoActualOptions"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                @input="(val) => (voucherRetake = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Learn Subscription Id -->
          <b-col cols="12" lg="4" md="6" xs="12">
            <b-form-group label="Learn Subscription Id" label-for="profile-section-learn-subscription-id">
              <b-form-input
                id="profile-section-learn-subscription-id"
                :value="getSectionLearnSubscriptionId()"
                @input="setSectionLearnSubscriptionId"
                class="w-100"
              />
            </b-form-group>
          </b-col>

          <template v-if="voucherRetake === 'yes' || profileDataLocal.sections[this.sectionId].vouchers.retake.voucherCode">
            <b-col cols="12" lg="2" md="6" xs="12">
              <b-form-group label="Re-Voucher Purchased" label-for="profile-section-re_voucher-purchased">
                <v-select
                  id="profile-section-re_voucher-purchased"
                  :value="profileDataLocal.sections[this.sectionId].vouchers.retake.voucherPurchased"
                  :options="yesNoOptions"
                  class="w-100"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.retake.voucherPurchased = val)"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Re-Voucher Issued -->
            <b-col cols="12" lg="2" md="6" xs="12">
              <b-form-group label="Re-Voucher Issued" label-for="profile-section-re_voucher-issued">
                <v-select
                  id="profile-section-re_voucher-issued"
                  :value="profileDataLocal.sections[this.sectionId].vouchers.retake.voucherIssued"
                  :options="yesNoOptions"
                  class="w-100"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.retake.voucherIssued = val)"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Re-Voucher Code -->
            <b-col cols="12" lg="2" md="6" xs="12">
              <b-form-group label="Re-Voucher Code" label-for="profile-section-re_voucher-code">
                <b-form-input
                  id="profile-section-re_voucher-code"
                  :value="profileDataLocal.sections[this.sectionId].vouchers.retake.voucherCode"
                  @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.retake.voucherCode = val)"
                  class="w-100"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Re-Voucher Issued Date -->
            <b-col cols="12" lg="2" md="6" xs="12">
              <b-form-group label="Re-Voucher Issued Date" label-for="profile-section-re_voucher-issued-date">
                <b-form-datepicker
                  id="profile-section-re_voucher-issued-date"
                  :value="profileDataLocal.sections[this.sectionId].vouchers.retake.voucherIssuedDate"
                  @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.retake.voucherIssuedDate = val)"
                  class="mb-1"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Re-Voucher Expiration Date -->
            <b-col cols="12" lg="2" md="6" xs="12">
              <b-form-group label="Re-Voucher Expiration Date" label-for="profile-section-re_voucher-expiration-date">
                <b-form-datepicker
                  id="profile-section-re_voucher-expiration-date"
                  :value="profileDataLocal.sections[this.sectionId].vouchers.retake.voucherExpirationDate"
                  @input="(val) => (profileDataLocal.sections[this.sectionId].vouchers.retake.voucherExpirationDate = val)"
                  class="mb-1"
                />
              </b-form-group>
            </b-col>
          </template>
        </b-row>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { BCard, BCol, BForm, BFormDatepicker, BFormGroup, BFormInput, BRow } from 'bootstrap-vue';
import vSelect from 'vue-select';
import useProfiles from '../../useProfiles';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    vSelect,
  },
  inject: ['profileEdit'],
  data() {
    return {
      voucherRetake: 'no',
    };
  },
  computed: {
    profileDataLocal() {
      return this.profileEdit.profileDataLocal;
    },
    sectionId() {
      return this.profileEdit.sectionId;
    },
    isCourseCohort() {
      return this.profileEdit.isCourseCohort;
    },
  },
  methods: {
    getSectionLearnSubscriptionId() {
      if (!this.sectionId || !this.profileDataLocal.sections || !this.profileDataLocal.sections[this.sectionId]) {
        return '';
      }

      const section = this.profileDataLocal.sections[this.sectionId];
      return section.learn && section.learn.subscription && section.learn.subscription.id ? section.learn.subscription.id : '';
    },
    setSectionLearnSubscriptionId(value) {
      if (!this.sectionId || !this.profileDataLocal.sections || !this.profileDataLocal.sections[this.sectionId]) {
        return;
      }

      const section = this.profileDataLocal.sections[this.sectionId];
      if (!section.learn) {
        this.$set(section, 'learn', {});
      }

      if (!section.learn.subscription) {
        this.$set(section.learn, 'subscription', {});
      }

      section.learn.subscription.id = value || null;
    },
  },
  mounted() {
    if (this.sectionId && this.profileDataLocal.sections[this.sectionId].vouchers.retake.voucherCode) {
      this.voucherRetake = 'yes';
    }
  },
  setup() {
    const { sectionStatusOptions, examVoucherOptions, yesNoOptions, yesNoActualOptions } = useProfiles();

    return {
      sectionStatusOptions,
      examVoucherOptions,
      yesNoOptions,
      yesNoActualOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .card {
  margin-bottom: 1rem;
}

::v-deep .card-body {
  padding-top: 1.25rem;
  padding-bottom: 0.75rem;
}

::v-deep .form-group {
  margin-bottom: 0.75rem;
}
</style>
